export default {
  handler: 'relativeUrl',
  data: ({ promoHubSection }) => `/offer${
    {
      SPORTSOFFERS: '/?product=sports',
      CASINOOFFERS: '/?product=casino',
      BONUSBALANCEBREAKDOWN: '/wallets',
    }[promoHubSection] || ''
  }`,
};
